import React from "react";
import { Circles } from "react-loader-spinner";
import { Portal } from "react-portal";

const GlobalSpinner = () => {
  return (
    <Portal>
      <div
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          backgroundColor: "rgba(255, 255, 255, 0.6)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          zIndex: 1000,
        }}
      >
        <Circles height="70" width="70" color="grey" ariaLabel="loading" />
      </div>
    </Portal>
  );
};

export default GlobalSpinner;
